export default __webpack_public_path__ + "img/4597c45e5fca34205dd966288bc5a2d8.png";